import axios from '../../axios';

export default {
  namespaced: true,

  state: {
    allPressPages: null,
    currentPressPage: null,
  },

  getters: {
    getAllPressPages: (state) => {
      if (state.allPressPages) {
        return state.allPressPages;
      }
    },
    getPressPageByURL: (state, getters) => (url) => {
      if (state.allPressPages) {
        return state.allPressPages.find((l) => l.cmsRelativeURL === url);
      }
    },
    getCurrentPressPage: (state) => {
      if (state.currentPressPage) {
        return state.currentPressPage;
      }
    },
  },

  mutations: {
    setAllPressPages(state, pressPages) {
      state.allPressPages = pressPages;
    },
    setCurrentPressPage(state, pressPage) {
      state.currentPressPage = pressPage;
    },
  },

  actions: {
    fetchPressPageById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        state.currentPressPage = null;
        const odata = '$select=*&$expand=properties($select=propertyId)';
        axios.get(`/core/presspages/published/${id}?${odata}`)
          .then((res) => {
            commit('setCurrentPressPage', res.data);
            resolve(res.data);
          });
      });
    },
    fetchPressArticles({
      commit, state, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/presspages/published/mediaType/${data.type}?pageSize=${data.pageSize}&fromPage=${data.from}&toPage=${data.to}`)
          .then((res) => {
            resolve(res.data);
          });
      });
    },
  },
};
